import type { FC } from "react";

import { Skeleton, Spacer } from "@aviary";
import { useBreakpoints } from "@shared/hooks";

import * as styles from "./ForgotPasswordForm.styles";

const SkeletonForgotPasswordForm: FC = () => {
  const { tablet } = useBreakpoints();

  return (
    <div css={styles.form}>
      <Spacer height="one" />
      <Skeleton type="button" isFullwidth />
      <Spacer height="one" />
      <Skeleton type="button" buttonSize="medium" isFullwidth={tablet.lessThan} />
    </div>
  );
};

export { SkeletonForgotPasswordForm };
